import React, {useEffect, useState} from "react";
import SplitterSection from "../../../components/Dashboard/SplitterSection.jsx";
import ExtractorSection from "../../../components/Dashboard/ExtractorSection.jsx";
import axios from "../../../utils/authAxios.js";
import {PiArrowBendUpLeftBold} from "react-icons/pi";
import {useLocation, useNavigate} from "react-router-dom";
import {MdEdit} from "react-icons/md";
import {FaTrash} from "react-icons/fa";
import ChangeDocumentTypeModal from "../../../components/modals/ChangeDocumentTypeModal";
import TestSection from "../../../components/Dashboard/TestSection";
import {Splitter} from "antd";
import ResultSection from "../../../components/Dashboard/ResultSection";

const Dashboard = () => {
    const [extractorData, setExtractorData] = useState([]);
    const [selectedTestFiles, setSelectedTestFiles] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const extractionId = params.get("ex_id");
    const [currentData, setCurrentData] = useState({});
    const [isChangeDocumentModalOpen, setChangeDocumentModalOpen] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const [showResult, setShowResult] = useState(true);
    const [currentView, setCurrentView] = useState({page: null, layout: null})
    const navigate = useNavigate();

    const getExtractionData = () => {
        axios
            .get(`/v1/templates`)
            .then((response) => {
                setExtractorData(response.data.items);
            })
            .catch((e) => console.log(e));
    };

    useEffect(() => {
        getExtractionData();
        return () => {
        };
    }, []);

    useEffect(() => {
        if (extractionId && extractorData.length > 0) {
            const extraction = extractorData.find((item) => item.template_id === extractionId);
            if (extraction) {
                setCurrentData(extraction);
            }
        }
    }, [extractionId, extractorData]);
    const deleteExtractor = () => {
        axios
            .delete(`/v1/templates/${extractionId}`)
            .then(() => navigate("/"))
            .catch((e) => console.log(e));
    };


    return (
        <div style={{height: "calc(100svh - 3rem)"}} className="w-full bg-gray-100 flex px-2 pb-2">
            <SplitterSection
                extractorData={extractorData}
                getExtractionData={getExtractionData}
                setSelectedTestFiles={setSelectedTestFiles}
            />

            <div className="bg-white rounded-lg w-full h-full overflow-hidden border">
                {extractorData.length === 0 ? (
                    <div className="flex flex-col w-full h-full items-center justify-center text-gray-500 relative">
                        <div className="absolute left-0 top-12">
                            <div>
                                <PiArrowBendUpLeftBold className="w-10 h-10 text-purple-500"/>
                                <div
                                    className="ml-4 px-3 py-2 -mt-2 border-2 rounded-lg border-purple-400 text-sm bg-purple-100 text-purple-500">
                                    Create your first template here!
                                </div>
                            </div>
                        </div>
                        <p className="text-xl mb-6">All-in-One Document Parser</p>
                        <div className="space-y-3 text-xs">
                            <div className="flex items-center space-x-2">
                                <div
                                    className="w-5 h-5 rounded-full bg-gray-400 flex items-center justify-center font-medium text-gray-200">
                                    1
                                </div>
                                <p className="text-gray-500">
                                    Upload to <span className="font-medium">'Analyze Document'</span> to auto-create
                                    a schema.
                                </p>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div
                                    className="w-5 h-5 rounded-full bg-gray-400 flex items-center justify-center font-medium text-gray-200">
                                    2
                                </div>
                                <p className="text-gray-500">
                                    Refine your schema in the <span
                                    className="font-medium">'Template Schema'</span> section.
                                </p>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div
                                    className="w-5 h-5 rounded-full bg-gray-400 flex items-center justify-center font-medium text-gray-200">
                                    3
                                </div>
                                <p className="text-gray-500">
                                    Test your model in the <span
                                    className="font-medium">'Test Template'</span> section.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={'w-full h-full'}>
                        <ChangeDocumentTypeModal
                            open={isChangeDocumentModalOpen}
                            setOpen={setChangeDocumentModalOpen}
                            getExtractionData={getExtractionData}
                            currentDocumentType={currentData.document_type || ''}
                            extractionId={extractionId}
                        />
                        <div className="flex px-3 h-12 items-center justify-between border-b text-nowrap">
                            <div className={'flex flex-col mr-3'}>
                                <p className="text-xs text-gray-500">Template ID: {currentData.template_id}</p>
                                <p>Document Type: {currentData.document_type}</p>
                            </div>
                            <div className="flex items-center space-x-1">
                                <button onClick={() => setChangeDocumentModalOpen(true)}
                                        className="bg-gray-100 text-gray-600 hover:text-blue-500 text-sm font-medium h-9 border-none flex items-center justify-center rounded-lg transition space-x-2 px-4">
                                    <MdEdit/>
                                    <p className="text-xs">Edit Document Type</p>
                                </button>
                                <button onClick={deleteExtractor}
                                        className="bg-gray-100 text-red-600 hover:text-red-500 text-sm font-medium h-9 border-none flex items-center justify-center rounded-lg transition space-x-2 px-4">
                                    <FaTrash className="w-2.5 h-2.5"/>
                                    <p className="text-xs">Delete template</p>
                                </button>
                            </div>
                        </div>
                        <Splitter style={{height: 'calc(100% - 3rem)'}}>
                            <Splitter.Panel defaultSize={322} min={322} max={"70%"}>
                                <TestSection currentData={currentData}
                                             extractionId={extractionId}
                                             setSelectedTestFiles={setSelectedTestFiles}
                                             selectedTestFiles={selectedTestFiles}
                                             testResult={testResult}
                                             setTestResult={setTestResult}
                                             showResult={showResult}
                                             setShowResult={setShowResult}
                                             currentView={currentView}
                                             setCurrentView={setCurrentView}
                                />
                            </Splitter.Panel>
                            <Splitter.Panel>
                                {testResult && showResult ?
                                    <ResultSection testResult={testResult} setShowResult={setShowResult}
                                                   currentView={currentView} setCurrentView={setCurrentView}/> :
                                    <ExtractorSection currentData={currentData}
                                                      getExtractionData={getExtractionData}/>}
                            </Splitter.Panel>
                        </Splitter>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;
